import * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as display from '../../../../display'
import type { Feature } from '../feature'

/** Announces a failed document download. */
export const showDownloadError = store.effects.create(
  (feature: Feature, toasterFeature: display.toaster.Feature) =>
    feature.actions.download.error.observe().pipe(
      rxjs.tap(action =>
        toasterFeature.actions.show
          .from('Admin.KnowledgeBases.Operation')
          .dispatch({
            toast: {
              description:
                feature.selectors
                  .downloadError(action.data.request.key)
                  .asSignal() ??
                'The knowledge base operation could not be completed.',
              name: 'Knowledge base operation failed',
              style: ents.core.display.Style.Error,
            },
          }),
      ),
      rxjs.ignoreElements(),
    ),
)
